import everydayRewardsEnrolmentStatus from '../response/accounts/everyday-rewards-enrolment-status.json';
import everydayRewardsLoginUri from '../response/accounts/everyday-rewards-login-uri.json';

export default function EverydayRewardsRoutes() {
  // Get Everyday Rewards Enrolment Status
  this.get('accounts-api/v1/loyalty/:contractIdentifier/enrolment', () => everydayRewardsEnrolmentStatus);

  // Get Everyday Rewards login URI
  this.get('accounts-api/v1/loyalty/loginUri', () => everydayRewardsLoginUri);

  // Connect to Everyday Rewards
  this.post('accounts-api/v1/loyalty/:contractIdentifier/connect', () => {});

  // Disconnect from Everyday Rewards
  this.post('accounts-api/v1/loyalty/:contractIdentifier/disconnect', () => {});
}
